import { render, staticRenderFns } from "./publishShopee.vue?vue&type=template&id=184521d6&scoped=true&"
import script from "./publishShopee.vue?vue&type=script&lang=js&"
export * from "./publishShopee.vue?vue&type=script&lang=js&"
import style0 from "./publishShopee.vue?vue&type=style&index=0&id=184521d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184521d6",
  null
  
)

export default component.exports